module.exports = __webpack_public_path__ + "img/editor.c655c847.svg";